import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Oaps from "./oaps";
import { newland } from "./newland";
import reportWebVitals from "./reportWebVitals";
import { HashRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
const params = new URLSearchParams(window.location.search);
const showNew = params.get("newoapsState");
const showOld = params.get("oapsState");
const showNewland = params.get("newland");

if (showOld || showNewland) {
  // 原生 JS 落地页，不需要 React 渲染
  newland();
} else {
  root.render(
    <HashRouter> <App /></HashRouter>,
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
